import React from 'react';
import { ServiceDetailPage } from './ServiceDetailPage';

export const SupervisionDeObra: React.FC = () => {
  const serviceData = {
    title: 'Supervisión de Obra',
    description: 'En LIEC, nos comprometemos a garantizar que sus proyectos se realicen dentro de los plazos establecidos y cumpliendo con los más altos estándares de calidad del mercado. Nuestra labor de supervisión forma parte de un equipo integral que busca asegurar el éxito de cada proyecto, no obstaculizar su desarrollo.',
    image: '/services/Ser_Int_Supervision.jpg',
    
  };

  return <ServiceDetailPage {...serviceData} />;
};
